// extracted by mini-css-extract-plugin
var _1 = "lrG0R";
export { _1 as "base" }
